import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(-277 -14)" fill="none">
                <path
                    d="M286.833 14c5.34 0 9.684 4.255 9.83 9.566l.004.276-.007.354a9.74 9.74 0 01-1.45 4.772l-.195.304-.161.228 3.67 3.66c.61.615.642 1.586.1 2.236l-.108.118-.12.11a1.669 1.669 0 01-2.127 0l-.118-.11-3.651-3.66-.229.161a9.743 9.743 0 01-4.717 1.625l-.363.02-.365.007-.277-.004c-5.31-.151-9.549-4.505-9.549-9.83 0-5.43 4.403-9.833 9.833-9.833zm0 3.333a6.499 6.499 0 00-6.496 6.26l-.004.232.004.232a6.499 6.499 0 006.256 6.272l.232.004.232-.003a6.5 6.5 0 00-.224-12.997z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};

export default React.memo(Search);
